import { Button, Flex, IconPlus, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { FieldGroupBox } from 'ui'
import styles from '../../styles'
import { messages } from '../messages'

type Props = {
  onAdd: () => void
  name: string
}

export function EmptyTrigger(props: Props) {
  const { onAdd, name } = props

  return (
    <FieldGroupBox name={name}>
      <Flex direction="column" className={styles.view.content}>
        <Text variant="action1">
          <FormattedMessage {...messages.title} values={{ index: 1 }} />
        </Text>
        <Button variant="secondary" icon={<IconPlus />} onClick={onAdd}>
          <FormattedMessage {...messages.empty.configDiscount} />
        </Button>
      </Flex>
    </FieldGroupBox>
  )
}
